<template>
  <p
    v-if="!isHeader"
    class="lty-perks-details-column cell auto grid-x align-center align-middle"
  >
    <svg
      v-if="typeof value === 'boolean' && value === true"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <circle
        cx="4"
        cy="4"
        r="4"
        fill="#626369"
      />
    </svg>
    <template v-else-if="typeof value !== 'boolean'">
      <span
        class="text-center"
        :class="brand === 'mcom' ? 'small' : ''"
        v-html="value"
      ></span>
    </template>
    <template v-else> &nbsp; </template>
  </p>
  <h6
    v-else
    class="lty-perks-details-column lty-perks-column-header cell auto text-center"
  >
    {{ value }}
  </h6>
</template>

<script setup>
import { toRefs } from 'vue';
import { brand } from '../../config';

const props = defineProps({
  value: {
    type: [Boolean, String, Number],
    default() {
      return false;
    },
  },
  isHeader: Boolean,
});

const { value, isHeader } = toRefs(props);
</script>
<style lang="scss">
.lty-perks-details-column {
  height: 100%;
}
</style>
